import { Outlet } from "react-router-dom";

export default function AuthLayout() {
  return (
    <div className="auth">
      <div className="auth__container">
        <div className="auth__content">
          <div className="auth__left">
            <Outlet />
          </div>
          <div className="auth__right"></div>
        </div>
      </div>
    </div>
  );
}
